import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AlertService } from '../../services/alert/alert.service';
import { Alert } from '../../services/alert/alert.interface';

@Component({
  selector: 'app-alert',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.scss'
})
export class AlertComponent {
  alert: Alert | null = null;

  constructor(
    private alertService: AlertService
  ) {}

  ngOnInit() {
    this.alertService.alert.subscribe((alert: any) => {
      this.alert = alert;
    });
  }
}
